// src/pages/UnitPreview.js - FINAL CLEAN VERSION
import React from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import './UnitPreview.css';

// Import UnitViewer components directly to build a read-only version
import { useUnitNavigation } from '../hooks/useUnitNavigation';
import { ProgressBar } from '../features/learner/components/Navigation/ProgressBar';
import { UnitNavigation } from '../features/learner/components/Navigation/UnitNavigation';
import { ContentRenderer } from '../features/learner/components/ContentRenderers/ContentRenderer';
import '../features/learner/UnitViewer.css';

function UnitPreview() {
  const { lessonId } = useParams();
  const [searchParams] = useSearchParams();
  const unitId = searchParams.get('unitId'); // Get specific unit ID from URL
  const { currentUser } = useAuth();
  
  // Use navigation hook - it will start at unitId automatically
  const {
    loading,
    currentUnitIndex,
    currentInternalIndex,
    allContent,
    getCurrentContent,
    getInternalContent,
    goToNextUnit,
    goToPrevUnit,
    goToInternalIndex,
    touchHandlers
  } = useUnitNavigation(lessonId, currentUser, unitId);
 
  if (loading) {
    return (
      <div className="unit-preview-wrapper">
        <div className="preview-banner">
          <span>📖 Preview Mode</span>
          <button onClick={() => window.close()} className="close-preview">
            ✕ Close Preview
          </button>
        </div>
        <div className="preview-loading">Loading content...</div>
      </div>
    );
  }

  const currentContent = getCurrentContent();
  const internalContent = getInternalContent();

  return (
    <div className="unit-preview-wrapper">
      <div className="preview-banner">
        <span>📖 Preview Mode - Read Only</span>
        <button onClick={() => window.close()} className="close-preview">
          ✕ Close Preview
        </button>
      </div>
      
      <div className="unit-viewer" {...touchHandlers}>
        <ProgressBar
          currentIndex={currentUnitIndex}
          totalUnits={allContent.length}
          internalIndex={currentInternalIndex}
          internalTotal={internalContent.length}
        />

        {/* Package Title if exists */}
        {currentContent?.title && internalContent.length > 1 && (
          <div className="package-title-display">
            <span className="package-title-text">{currentContent.title}</span>
          </div>
        )}

        <div className="main-content">
          <ContentRenderer
            content={internalContent.length > 0 ? internalContent[currentInternalIndex] : currentContent}
            userAnswers={{}} // Empty - read only
            showFeedback={false} // No feedback in preview
            completedUnits={[]} // Empty - read only
            selectedHotspot={null}
            visitedHotspots={[]}
            currentInternalIndex={currentInternalIndex}
            internalContent={internalContent}
            onAnswerSelect={() => {}} // Disabled
            onCheckAnswer={() => {}} // Disabled
            onMarkCompleted={() => {}} // Disabled
            onHotspotClick={() => {}} // Disabled
            onPlayAudio={() => {}} // Could work
            onSetSelectedHotspot={() => {}} // Disabled
            getRandomizedOptions={() => []} // Empty
          />
        </div>

        <UnitNavigation
          currentIndex={currentUnitIndex}
          internalIndex={currentInternalIndex}
          totalUnits={allContent.length}
          internalContent={internalContent}
          visitedPages={new Set()}
          visitedUnits={new Set()}
          completedUnits={{}}
          currentContent={currentContent}
          onPrevUnit={goToPrevUnit}
          onNextUnit={goToNextUnit}
          onInternalNavigation={goToInternalIndex}
          onGoToInternal={goToInternalIndex}
          hideUnitArrows={true}
        />
      </div>
    </div>
  );
}

export default UnitPreview;